import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFilter } from '../actions/setFilters';
import { Slider, makeStyles } from '@material-ui/core';
import { scaledPriceSlider } from '../data';
import styles from '../css/filter.module.css';
import { useEffect } from 'react';

const { scale, unscale, min, max, step, marks } = scaledPriceSlider();

const useStyles = makeStyles({
    slider: {
        color: 'var(--gold)',
        '& span': {
            ' & span': {
                ' & span': {
                    ' & span': {
                        color: 'var(--side-color)',
                        fontWeight: '700',
                        textAlign: 'center',
                        lineHeight: '.6rem',
                    },
                },
            },
        },
    },
    expansionSummary: {
        textTransform: 'uppercase',
        fontWeight: '700',
        padding: 0,
    },
});

const PriceSlider = (props) => {
    const classes = useStyles();

    const [priceRange, setPriceRange] = useState([0, 400]);

    const reduxPrice = useSelector((state) => state.filters.price);
    useEffect(() => {
        if (reduxPrice.length) {
            setPriceRange(reduxPrice);
        }
    }, [reduxPrice]);

    const dispatch = useDispatch();
    const handleChangePrice = (newValue) => {
        setPriceRange(newValue);
    };
    const handleChangePriceCommited = () => {
        dispatch(updateFilter('price', priceRange));
    };

    return (
        <>
            <h3
                className={classes.expansionSummary}
                style={{ marginBottom: '1rem' }}
            >
                Price Range:
                <span className={styles.num}>($)</span>
            </h3>
            <Slider
                className={classes.slider}
                marks={marks}
                step={step}
                min={min}
                max={max}
                scale={scale}
                value={[unscale(priceRange[0]), unscale(priceRange[1])]}
                onChange={(event, data) =>
                    handleChangePrice([scale(data[0]), scale(data[1])])
                }
                onChangeCommitted={handleChangePriceCommited}
            />
        </>
    );
};

export default PriceSlider;
